/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
 
interface IDataPrint {
  idvale: string,
  dataemissao: Date;
  totalvale: number 
  produtor: string;
  numero: string;
  realizacao: string;
  colaborador: string;
  endereco: string;
  cpf: string;
  rg: string;
}


async function PDFReciboVale(dadosrecibo: IDataPrint){
  
  const numero = require('numero-por-extenso');
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {  
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

 
  const documentDefinition = {

    content: [
     
      {
        table: {
          widths: [50, 180, 130, 130],
          body: [
            [ 
              {
                image: imageData,
                width: 50,
                border: [true, true, false, true] 
              },
              {text: 'Recibo', fontSize: 25, margin: [0, 10, 0, 0], alignment: 'center', border: [false, true, true, true] },
              {text: 'Valor\n'+ new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(dadosrecibo.totalvale), fontSize: 18, alignment: 'center', }, 
              {text: 'Data\n '+ moment(dadosrecibo.dataemissao).format('DD/MM/YYYY'), fontSize: 18, alignment: 'center', },
            ],
            [
              {
                colSpan: 4,
                text: 'Recebi do:  '+dadosrecibo.produtor,
                heights: 10,
              }, 
            ],  
            [
              { 
                colSpan: 4,
                text: 'CEI: '+ dadosrecibo.numero+'                                           Inscrição Estadual: Isento',
                margin: [0, 5, 0, 5],
                heights: 10,
              },       
            ],
            [
              {  
                colSpan: 4,
                text: 'a importância de: '+numero.porExtenso(dadosrecibo.totalvale, numero.estilo.monetario),
                heights: 10,
              },
      
            ],   
            [
              {  
                colSpan: 4 ,
                text: 'em realizações de: '+dadosrecibo.realizacao,
                heights: 10,
              },
      
            ],
            [                            
              {
                colSpan: 4,
                table: {
                  widths: [245, 245],
                  body: [
                    [{text: '', border: [false, false, false, false], }, 'Pelo Que Damos Plena e Geral Quitação'],
                    [{text:'Serviços......'+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(0) , border: [false, false, false, false],}, {text: 'Nome..: '+dadosrecibo.colaborador, border: [true, false, true, false]} ],
                    [{text:'Varbas........'+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(0) , border: [false, false, false, false],}, {text: 'Local.: São Felix do Coribe-Ba', border: [true, false, true, false],}],
                    [{text:'Total.........'+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(dadosrecibo.totalvale) , border: [false, false, false, false],}, {text: 'CPF...: '+dadosrecibo.cpf, border: [true, false, true, true],}],
                    [{text:'', border: [false, false, false, false],}, {text: '___________________________________ \n'+dadosrecibo.colaborador, border: [false, false, false, false], alignment: 'center',  margin: [0, 50, 0, 30]}],
                  ]
                },
                border: [true, false, true, false],
              }
            ],
            [
              {  
                colSpan: 4,
                text: 'Por ser expressão de verdade, dou quitação pela importância recebida, firmando o presente recibo nesta data.',
                heights: 10,
                fontSize: 9,
                border: [true, false, true, true],
              },
            ],
            [
              {   
                text:'',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {   
                text:'',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {   
                text:'',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {   
                text:'',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {   
                text:'',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
          ],
        }
      }
    ]
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFReciboVale;

